<form [formGroup]="witnessForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="formal" *ngIf="!witnessFormVisible">
    <h1 class="blue">{{title}}</h1>
    <p class="lead local">{{subtitle}}</p>
    <div class="row witness"
      style="display: flex; align-items: center; justify-content: center; margin-top: 30px; margin-bottom: 35px;">
      <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
        labelOptionA="Add witnesses already known to the testator" labelOptionB="Add witnesses after Will is prepared"
        (valueChange)="onOptionChange($event)">
      </app-radios>
    </div>
  </div>

  <div class="form-80" *ngIf="witnessFormVisible">
    <h1 class="blue margin">{{title}}</h1>
    <p class="lead rocal">{{ witnessFormVisible ? subtitleAlt : subtitle}}</p>

    <!-- Panel 1: Witness Details -->
    <ng-template #witnessInfo let-i="index">
      <div *ngIf="getWitnessFormGroup(i)">
        <div class="line-section"></div>

        <div class="row-alt">
          <div class="row-mini">
            <app-input [formGroup]="getWitnessFormGroup(i)" controlName="Title" label={{titleLabel}} hint={{titleHint}}
              inputType="auto-complete" [loadingOptions]="loadingTitles" [ArrayItems]="TitleOptions" required="false"
              [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>

            <app-input [formGroup]="getWitnessFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
              hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

          </div>

          <div class="row-mini">
            <app-input [formGroup]="getWitnessFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
              hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getWitnessFormGroup(i)" controlName="LastName" label={{surnameLabel}}
              hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

        </div>

        <div class="row">
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="Phone" label={{phoneLabel}}
            inputType="phone" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="Email" label={{emailLabel}}
            hint={{emailLabel}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>

        <div class="row">
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="IDNo" label={{idLabel}}
            hint={{idHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="PostalAddress"
            label={{postalLabel}} hint={{postalHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getWitnessFormGroup(i)">
        <div class="line-section"></div>

        <div class="row">
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="IDNoImage"
            label={{idFileLabel}} [fileFunction]="updateIDObject.bind(this, i)"
            [existingFileName]="witnesses[i]?.IDNoImage?.name != '' ? witnesses[i]?.IDNoImage?.name : '' "
            inputType="file" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" [required]="region == 1 ? 'false' : 'true' "
            [subtext]="region == 1 ? 'KRA PIN is optional' : '' " controlName="KraPinImage" label={{kraFileLabel}}
            [fileFunction]="updateKraObject.bind(this, i)"
            [existingFileName]="witnesses[i]?.KraPinImage?.name != '' ? witnesses[i]?.KraPinImage?.name : '' "
            inputType="file" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half">
          <app-input [formGroup]="getWitnessFormGroup(i)" class="grid-item" controlName="PassportImage"
            label={{photoLabel}} [fileFunction]="updatePhotoObject.bind(this, i)"
            [existingFileName]="witnesses[i]?.PassportImage?.name != '' ? witnesses[i]?.PassportImage?.name : '' "
            inputType="file" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <div formArrayName="witnesses">
      <div *ngFor="let witness of getWitnesses().controls; let i=index" [formGroupName]="i" style="position: relative;">

        <div style="height: 40px;" *ngIf="i > 1"></div>
        <p style="font-weight: 600; font-size: 1.3em;" class="blue margin" *ngIf="getWitnesses().length > 1">
          {{'Witness ' + (i+1)}}
        </p>

        <!-- Accordion -->
        <app-section [panels]="witnessPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <div class="action-buttons">
          <button *ngIf="i > 0" mat-stroked-button type="button" class="remove" (click)="removeWitness(i)">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{ getWitnesses().controls.length-1 === i ? removeButtonText : removeWitnessText
                  }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getWitnesses() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update witness ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Witness -->
    <div class="blueStroke row" style="margin-top: 16px;" [ngClass]="{'min-55' : getWitnesses().length > 1}">
      <button mat-stroked-button *ngIf="witnesses[witnesses.length-1] && witnesses[witnesses.length-1].done === true"
        [disabled]="loading || loadingRemove" class="general-stroked-button" type="button" (click)="addNewWitness()">
        <span class="button-text">
          {{addWitnessText}}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService" [text]="
            loading ? loadingText :
            !witnessFormVisible || (witnesses[witnesses.length-1] && witnesses[witnesses.length-1].done) ? 'Next' :
            (witnesses[witnesses.length-1] && witnesses[witnesses.length-1].verified) ? 'Upload documents' :
            'Save Details'" [formValid]="
            witnessForm.valid || !witnessFormVisible ? true : false
        "
    [showContinue]="witnessForm.pristine || witnessForm.valid || witnesses[witnesses.length-1].done ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)" [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>